<script lang="ts">
  import Modal from '$components/elements/Modal.svelte';
  import ModalImageHeader from '$components/elements/ModalImageHeader.svelte';
  import { requestPasswordReset, requestVerification } from '$lib/client/pocketbase/users';
  import { showEmailBlocker } from '$lib/stores';
  import type { EmailRequestType } from '$types/interfaces';

  let requestBlocked = false;
  let countDown = 60;

  function requestAndBlock(email: string, type: EmailRequestType) {
    if (requestBlocked) return;
    requestBlocked = true;
    if (type === 'verification') requestVerification(email);
    if (type === 'password-reset') requestPasswordReset(email);
    const interval = setInterval(() => {
      countDown--;
      if (countDown === 0) {
        clearInterval(interval);
        requestBlocked = false;
        countDown = 60;
      }
    }, 1000);
  }
</script>

<Modal showModal={$showEmailBlocker !== false} closable={false} overlayOnMobile>
  <div class="continue-to-email">
    <ModalImageHeader>
      <svg
        width="122"
        height="122"
        viewBox="0 0 122 122"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.7917 101.666C15.7584 101.666 13.9792 100.904 12.4542 99.3788C10.9292 97.8538 10.1667 96.0747 10.1667 94.0413V27.958C10.1667 25.9247 10.9292 24.1455 12.4542 22.6205C13.9792 21.0955 15.7584 20.333 17.7917 20.333H104.208C106.242 20.333 108.021 21.0955 109.546 22.6205C111.071 24.1455 111.833 25.9247 111.833 27.958V94.0413C111.833 96.0747 111.071 97.8538 109.546 99.3788C108.021 100.904 106.242 101.666 104.208 101.666H17.7917ZM61.0001 63.2872L17.7917 34.9476V94.0413H104.208V34.9476L61.0001 63.2872ZM61.0001 55.6622L103.7 27.958H18.4272L61.0001 55.6622ZM17.7917 34.9476V27.958V94.0413V34.9476Z"
          fill="#1D1D1B"
        />
      </svg>
    </ModalImageHeader>
    <div class="continue-to-email__content">
      <h1>Přejděte do e-mailu.</h1>
      <p>Obdrželi jste e-mail, který Vám umožní pokračovat dál.</p>
    </div>
    {#if $showEmailBlocker instanceof Object && 'email' in $showEmailBlocker && 'type' in $showEmailBlocker}
      {@const email = $showEmailBlocker.email}
      {@const type = $showEmailBlocker.type}
      <div class="continue-to-email__resend-verification">
        <h2>Neobdrželi jste očekávaný e-mail?</h2>
        {#if requestBlocked}
          <h3>Znovu za {countDown} s</h3>
        {:else}
          <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
          <h3
            on:click={() => requestAndBlock(email, type)}
            on:keydown={() => requestAndBlock(email, type)}
          >
            Odeslat znovu
          </h3>
        {/if}
      </div>
    {/if}
  </div>
</Modal>

<style lang="scss">
  .continue-to-email {
    width: 100%;
    padding-bottom: 26px;
    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 24px;
      padding: 24px 0;
      text-align: center;
      h1 {
        font-size: 28px;
        text-align: center;
      }
      p {
        font-size: 16px;
        line-height: 1.6;
        text-align: center;
        max-width: 308px;
      }
    }
    &__resend-verification {
      width: calc(100% - 32px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-top: 1px solid $color-medium-gray;
      padding: 24px 0 0;
      margin: 0 auto;
      h2 {
        font-size: 12px;
        line-height: 1.6;
        margin: 0;
        color: rgba($color-dark-gray, 0.4);
        font-weight: 500;
      }
      h3 {
        font-size: 12px;
        line-height: 1.6;
        margin: 0;
        cursor: pointer;
        text-decoration: underline;
        color: rgba($color-dark-gray, 0.4);
        font-weight: 500;
      }
    }
  }
</style>
